import React from 'react';
import { Manager } from 'react-popper';
import { UnsafeSpreadProps } from '@tanium/coreui-utils';

export interface TooltipManagerProps extends UnsafeSpreadProps {
  children?: React.ReactNode;
}

/**
 * A manager component for the Tanium Tooltip.
 *
 * Should be supplied with a TooltipReference and a Tooltip component as children.
 */
export const TooltipManager = ({ children, __UNSAFE_ADDITIONAL_PROPS__ }: TooltipManagerProps) => (
  <Manager {...__UNSAFE_ADDITIONAL_PROPS__}>{children}</Manager>
);
